import styled, { css } from "styled-components";

import fonts from "core/fonts";
import { regular } from "core/fontStyles";
import colors from "core/colors";
import { easingSeconds } from "core/animation";
import breakpoints from "core/breakpoints";

const TagsAndButton = css`
    display: inline-block;
    color: ${colors.secondary.oolong};
    text-decoration: none;
    padding: 5px 10px;
    background: ${colors.primary.diamond};
    ${fonts.typeScale[12]};
    border: 1px solid transparent;
    transition: all ${easingSeconds};

    &:hover,
    &:focus {
        background: ${colors.primary.moon};
        color: ${colors.secondary.cosmic};
    }

    /* mobile-only: */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        margin-top: 1.5rem; /* 24px */
    }

    /* tablet + desktop: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        margin-bottom: 1.5rem; /* 24px */
    }
`;

export const Tag = styled.a`
    ${TagsAndButton};
    margin-right: 16px;
    ${fonts.typeScale[12]};
    ${regular}
    text-transform: lowercase;
    &:last-of-type {
        margin-right: 0;
    }
`;

export const MoreButton = styled.button`
    ${TagsAndButton};
    cursor: pointer;
    background: #fff;
    border-color: ${colors.primary.pigeon};
    margin: 0;
    overflow: hidden;

    &:after {
        position: relative;
        ${props => (props.open ? "bottom" : "top")} 11px;
        content: "";
        width: 0;
        height: 0;
        margin-left: 4px;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        ${props => (props.open ? "border-bottom" : "border-top")} 6px solid
            ${colors.secondary.oolong};
    }

    &:hover {
        border-color: transparent;
    }

    &:hover,
    &:focus {
        &:after {
            ${props =>
                props.open ? "border-bottom-color" : "border-top-color"} #fff;
        }
    }
`;
